<template>
  <v-container fluid>
    <v-card class="elevation-2 py-1 px-6 mt-4 rounded-lg">
      <v-row class="px-4 pb-0 pt-3">
      <h3>Applicators</h3>
      </v-row>
      <v-container class="mt-5">
        <v-data-table :headers="headers" :items="data_applicators" class="elevation-1"></v-data-table>
      </v-container>
    </v-card>

    <v-card class="elevation-2 py-1 px-6 mt-4 rounded-lg d-none">
      <h3>Table2</h3>
        <v-card-text>
          <h3>Table3</h3>


          <v-data-table
              :footer-props="{
                  'items-per-page-options': [10, 25, 50, 75, 100, -1]
                  }"
              :items-per-page="25"
              dense
              :headers="headers"
              :items="data_applicators"
              :page.sync="pagination.page"
              item-key="Id"
              class="elevation-0 mt-2 table-main-container"
              :loading="loaded"
              loading-text="Loading... Please wait"

              fixed-header
              height="609"

          >
            <!--  events table  -->

          </v-data-table>
        </v-card-text>

    </v-card>
  </v-container>
</template>

<script>
 import axios from "@/api/axios-auth";


 export default {
  name: 'Sellnetics_Applicators',

  data() {
  return {
  message: 'Hello World',
    loaded: false,
    data_applicators: [],
    pagination: {
      page: 1
    },
    hoverOnTable: false,
    headers: [
      {text: 'Name', value: 'Name', class: 'black--text', filterable: false, sortable: true},
      {text: 'Email', value: 'Email', class: 'black--text'},
      {text: 'Requestor Email', value: 'RequestorEmail', class: 'black--text'},
      {text: 'Request Date', value: 'RequestDate', class: 'black--text'},
    ],

  };
},
   created() {

     this.loadApplicatorsData()
   },

  methods: {
  greet() {
  alert(this.message);
},
    loadApplicatorsData(){
      this.data_applicators = [];
      axios.get('/rural-applicator/get-applicator-tables', {

        params: {
          Offset: 0,
          Limit: 100000,
          OrderBy: 'Id',
          OrderDirAsc: true,
          IsCountRequired: true
        }
      })
          .then((resp)=>{

            this.data_applicators = resp.data.data.data;
            this.loaded = false;
          })
    },
},
  mounted() {
  console.log('Component has been mounted');
}
};
</script>




<style >

</style>
